export default "__VITE_ASSET__CUHQbj_B__"